import { render, staticRenderFns } from "./RacerDashboard.vue?vue&type=template&id=054e7cd7"
import script from "./RacerDashboard.vue?vue&type=script&lang=js"
export * from "./RacerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports